import React from "react";
import SleekPaySettingsFormContainer from "./SleekPaySettingsFormContainer";

export default function GeneralTab() {
  return <SleekPaySettingsFormContainer />;
}
